import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useLang } from "@/contexts/LanguageContext";

const SECTIONS = ["introHtml", "visionHtml", "missionHtml", "valuesHtml", "whyHtml"];

const AboutSection = ({ title, html, className = "", sectionKey }) => (
  <div className={`about-section ${className}`} data-testid={`about-${sectionKey}`}>
    {title && (
      <h2
        className="font-display font-extrabold text-white mb-4"
        style={{ fontSize: "clamp(1.4rem, 2.4vw, 2rem)" }}
      >
        {title}
      </h2>
    )}
    <div
      className="about-content text-white/85 leading-relaxed"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  </div>
);

const About = () => {
  const { t } = useLang();
  const a = t.about;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="about-page" className="min-h-screen bg-emka">
      <Header />

      <section className="pt-[150px] lg:pt-[170px] pb-16">
        <div className="max-w-[1100px] mx-auto px-4 sm:px-6 lg:px-10">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-white/75 hover:text-white text-xs font-semibold tracking-widest uppercase mb-5"
          >
            <ArrowLeft size={14} />
            {t.category.backHome}
          </Link>
          <p
            className="text-[12px] font-bold tracking-[0.32em] uppercase"
            style={{ color: "var(--emka-gold)" }}
          >
            {a.eyebrow}
          </p>
          <h1
            className="mt-3 font-display font-extrabold text-white leading-tight"
            style={{ fontSize: "clamp(2rem, 4vw, 3rem)" }}
          >
            {a.heroTitle}
          </h1>
          <span className="gold-divider mt-4" />

          <div className="mt-10 space-y-12">
            <AboutSection
              sectionKey={SECTIONS[0]}
              title={null}
              html={a.introHtml}
              className="about-lead"
            />
            <div className="grid md:grid-cols-2 gap-8">
              <AboutSection
                sectionKey={SECTIONS[1]}
                title={a.visionTitle}
                html={a.visionHtml}
              />
              <AboutSection
                sectionKey={SECTIONS[2]}
                title={a.missionTitle}
                html={a.missionHtml}
              />
            </div>
            <AboutSection
              sectionKey={SECTIONS[3]}
              title={a.valuesTitle}
              html={a.valuesHtml}
            />
            <AboutSection
              sectionKey={SECTIONS[4]}
              title={a.whyTitle}
              html={a.whyHtml}
            />
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default About;
